import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MediaService } from '../../../../../../admin/src/app/services/media.service';
import { Media } from '../../../../../../admin/src/app/models/media';
import { Asset } from '../../../../../../admin/src/app/models/asset';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-product-media',
  templateUrl: './product-media.component.html',
  styleUrls: ['./product-media.component.css']
})
export class ProductMediaComponent implements OnInit, OnDestroy {

  productId: string;

  media: Media[];

  zoomImage: Asset;

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private mediaSvc: MediaService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Product media');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getFaqs();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getFaqs() {
    this.mediaSvc.getAll(this.productId).subscribe(data => {
      this.media = Object.assign([], data.payload.elements);
    });
  }

  zoomIn(asset: Asset) {
    this.zoomImage = asset;
  }

  zoomOut() {
    this.zoomImage = null;
  }

}
